var map = {
	"./application/mobile/devices.json": [
		13611,
		3611
	],
	"./application/native_mobile/devices.json": [
		60881,
		881
	],
	"./application/web/devices.json": [
		4009,
		4009
	],
	"./prefab/default/devices.json": [
		72898,
		2898
	],
	"./templatebundle/mobile/devices.json": [
		77455,
		7455
	],
	"./templatebundle/web/devices.json": [
		70677,
		677
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 876;
module.exports = webpackAsyncContext;